export const AuthActionTypes = {
  Login: 'AUTH_LOGIN',
  LoginSuccess: 'AUTH_LOGIN_SUCCESS',
  LoginError: 'AUTH_LOGIN_ERROR',
  RefreshToken: 'AUTH_REFRESH_TOKEN',
  RefreshTokenSuccess: 'AUTH_REFRESH_TOKEN_SUCCESS',
  RefreshTokenError: 'AUTH_REFRESH_TOKEN_ERROR',
  VerifyTokenSuccess: 'AUTH_VERIFY_TOKEN_SUCCESS',
  LogoutUser: 'AUTH_LOGOUT_USER',
  LogoutUserSuccess: 'AUTH_LOGOUT_USER_SUCCESS',
  ResetPassword: 'AUTH_RESET_PASSWORD',
  ResetPasswordSuccess: 'AUTH_RESET_PASSWORD_SUCCESS',
  ResetPasswordError: 'AUTH_RESET_PASSWORD_ERROR',
  ForgotPassword: 'AUTH_FORGOT_PASSWORD',
  ForgotPasswordSuccess: 'AUTH_FORGOT_PASSWORD_SUCCESS',
  ForgotPasswordError: 'AUTH_FORGOT_PASSWORD_ERROR',
  VerifyResetPasswordToken: 'AUTH_VERIFY_RESET_PASSWORD_TOKEN',
  VerifyResetPasswordTokenSuccess: 'AUTH_VERIFY_RESET_PASSWORD_TOKEN_SUCCESS',
  VerifyResetPasswordTokenError: 'AUTH_VERIFY_RESET_PASSWORD_TOKEN_ERROR',
  GetKenticoProject: 'AUTH_GET_KENTICO_PROJECT',
  GetKenticoProjectError: 'AUTH_GET_KENTICO_PROJECT_ERROR',
  ChooseKenticoProject: 'AUTH_CHOOSE_KENTICO_PROJECT',
  GetProjectPrefix: 'AUTH_GET_PROJECT_PREFIX',
  GetProjectPrefixSuccess: 'AUTH_GET_PROJECT_PREFIX_SUCCESS',
  GetProjectPrefixError: 'AUTH_GET_PROJECT_PREFIX_ERROR',
  GetUserConfig: 'AUTH_GET_USER_CONFIG',
  GetUserConfigError: 'AUTH_GET_USER_CONFIG_ERROR',
  GetUserConfigSuccess: 'AUTH_GET_USER_CONFIG_SUCCESS',
};
